export default {
    "rider": "Rider Sum Assured must be Less than Product\'s Sum Assured",
    'MINIMUM_RIDER_AGE': "Minimum Entry age for riders is 18 years",
    "MAXIMUM_RIDER_AGE": "Maximum Entry age for riders is 65 years",
}